import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import { deletePersonnel } from "repository/actions/data/dashboard/personnel";

export default withSnackbar(
  withRouter(function (props) {
    const { isOpen, setClose, person, user } = props;
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteItem = () => {
      if (user && user != null) {
        setSaveLoading(true);
        deletePersonnel(person._id, user.idToken)
          .then((result) => {
            setClose();
            setSaveLoading(false);
            toast.success("Successfully deleted document");
            window.location.href = "/administration/personnel";
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete person"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteItem()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete {person.title}
              {person.firstName} {person.lastName}?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
